import { render, staticRenderFns } from "./ListNewsletterPage.vue?vue&type=template&id=415519c0"
import script from "./ListNewsletterPage.vue?vue&type=script&lang=js"
export * from "./ListNewsletterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports